export const DAY_NAMES = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'];
export const RANGE_DELIMITER = '–';

export const MS_IN_DAY = 1000 * 60 * 60 * 24;

// Сколько месяцев дорисовывается за одну подгрузку в scroll-режиме
export const SCROLL_MONTHS_SIZE = 3;
// Запас до конца скролла (с учётом padding-bottom контейнера 256px), при котором подгружаются следующие месяцы
export const SCROLL_LOAD_DISTANCE = 300;
